// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-info[data-v-0361b67f]{width:600px;height:748px;background:#f5f6fa;border-radius:2px}.card-list[data-v-0361b67f]{margin-top:0!important;margin-bottom:20px}[data-v-0361b67f] .el-form-item__content{line-height:20px!important;color:#606166;font-weight:400}[data-v-0361b67f] .el-form-item__label{padding-bottom:0!important;line-height:20px!important}.el-form-item[data-v-0361b67f]{margin-bottom:5px!important}.content-card[data-v-0361b67f]{height:748px}", ""]);
// Exports
module.exports = exports;
